import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  COMMODITY_REPORTS_BASE,
  COMMODITY_REPORTS_MANIFEST_URL,
  DEFAULT_DESK_PRESENTATION,
  DESK_PRESENTATION,
} from './commodity-reports.data';
import {
  CommodityDesk,
  CommodityReportsManifest,
  DeskPresentation,
} from './commodity-reports.model';

/**
 * Fetches the commodity-reports manifest and resolves report URLs. The manifest
 * carries relative URLs; this service prefixes the content base so links point
 * at the hosted reports.
 */
@Injectable({ providedIn: 'root' })
export class CommodityReportsService {
  constructor(private readonly http: HttpClient) {}

  getManifest(): Observable<CommodityReportsManifest> {
    return this.http.get<CommodityReportsManifest>(
      COMMODITY_REPORTS_MANIFEST_URL,
    );
  }

  /**
   * Absolute URL for a manifest-provided report path. Manifest paths carry a
   * leading dated snapshot segment (e.g. "/2026-07-12/…") that is not part of
   * the served bundle path, so it is stripped before prefixing the base:
   * "/2026-07-12/index.html" → "{base}/index.html".
   */
  reportUrl(relativeUrl: string): string {
    const path = relativeUrl.replace(/^\/\d{4}-\d{2}-\d{2}(?=\/)/, '');
    return `${COMMODITY_REPORTS_BASE}${path}`;
  }

  /** Presentation metadata (icon/subtitle) for a desk, with a safe fallback. */
  deskPresentation(desk: CommodityDesk): DeskPresentation {
    return DESK_PRESENTATION[desk.id] ?? DEFAULT_DESK_PRESENTATION;
  }
}
